import React, { useContext } from 'react';

import { languageOptions } from '../languages';
import { LanguageContext } from '../container/Language';

export default function LanguageSelector() {
    const { userLanguage, userLanguageChange } = useContext(LanguageContext);

    const style = {
        fontFamily: 'Poppins',
        color: 'darkslategray',
        border: '0',
        borderBottom: '1px double #bcc3eb'
    }

    // set selected language by calling context method
    const handleLanguageChange = e => userLanguageChange(e.target.value);

    return (
        <select style={style}
            onChange={handleLanguageChange}
            value={userLanguage}
        >
            {Object.entries(languageOptions).map(([id, name]) => (
                <option key={id} value={id}>{name}</option>
            ))}
        </select>
    );
};